import React from 'react'
import { Box } from '@mui/material'

import { dsColorNew } from '@palette'
import { CMP_WORD } from '../@services/format'


// Always visible under the grid (CA 18): one colour rule for the whole screen, with sign and arrow
export default function Legend({ cmp, code }) {
	const item = { display: 'inline-flex', alignItems: 'center', gap: 0.75 }
	return <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', gap: 2, flexWrap: 'wrap', mt: 1.5, fontSize: 12, color: dsColorNew.textMuted }}>
		<Box sx={{ display: 'flex', alignItems: 'center', gap: 2, flexWrap: 'wrap' }}>
			<Box component="span" sx={{ ...item, color: dsColorNew.successText }}><b>▼ −</b> cheaper than {CMP_WORD[cmp]}</Box>
			<Box component="span" sx={{ ...item, color: dsColorNew.dangerRed }}><b>▲ +</b> dearer than {CMP_WORD[cmp]}</Box>
			<Box component="span" sx={item}><b>=</b> no change</Box>
			<Box component="span" sx={item}>
				<Box component="i" sx={{ width: 14, height: 14, borderRadius: '4px', border: '1px solid rgba(21,128,61,.45)', backgroundColor: 'rgba(21,128,61,.06)' }}/>cheapest of the date
			</Box>
			<Box component="span" sx={item}>
				<Box component="i" sx={{
					width: 15, height: 15, borderRadius: '50%', backgroundColor: dsColorNew.noteAmberBg, border: `1px solid ${dsColorNew.noteAmberBorder}`,
					color: dsColorNew.noteAmber, fontSize: 10, fontWeight: 800, fontStyle: 'normal', display: 'inline-flex', alignItems: 'center', justifyContent: 'center',
				}}>!</Box>few prices behind (under 5)
			</Box>
		</Box>
		<Box component="span" sx={{ color: dsColorNew.textSubtle }}>Prices in {code || 'EUR'}, total for the rental · click a cell for details</Box>
	</Box>
}
